import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './../styles/default.css';
import './../styles/categorias.css';
import * as globals from './../components/GlobalScripts.js';
import NavbarTop from './default/Navbartop';
import Testimonials from './default/Testimonials';
import Preguntas from './default/Preguntas';
import Footer from './default/Footer';
import Rating from './rating/Rating';

import banner1 from './../components/categorias/banner1.jpg';

const Categorias = () => {
    let path_api = localStorage.getItem('path_api');
    const location = useLocation();
    const navigate = useNavigate();
    const { categoria } = useParams();

    const [user, setUser] = useState([]);
    const [profesionales, setProfesionales] = useState([]);
    const [profesionalesRecomendados, setProfesionalesRecomendados] = useState([]);
    const [categoriasOptions, setCategoriasOptions] = useState([]);
    const [categoriasDescripciones, setCategoriasDescripciones] = useState([]);
    const [estadosCiudades, setEstadosCiudades] = useState([]);
    const [formDataSearch, setFormDataSearch] = useState({
        categoria: categoria ?? "Mudanzas",
        titulo: "",
        descripcion_servicio: "",
        estado: "Aguascalientes",
        ciudad: "Aguascalientes",
    });
    const [descripcionPlaceholder, setDescripcionPlaceholder] = useState("Ej. Me cambio de casa y necesito trasladar mis muebles y electrodomésticos de forma segura.");
    const [formDataSearchAct, setFormDataSearchAct] = useState({});

    useEffect(() => {
        const cachedData = localStorage.getItem('formDataSearch');
        if (cachedData) {
            setFormDataSearch(JSON.parse(cachedData));
            setFormDataSearchAct(JSON.parse(cachedData));
        } else {
            localStorage.setItem('formDataSearch', JSON.stringify(formDataSearch));
            setFormDataSearchAct(formDataSearch);
        }

        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            setUser(JSON.parse(user_cache));
        }

        get_categorias();
        get_estados_ciudades();
    }, []);

    useEffect(() => {
        if (formDataSearchAct?.categoria)
            get_profiles();
    }, [formDataSearchAct]);

    useEffect(() => {
        let placeholder = "";
        for (let i = 0; i < categoriasOptions.length && formDataSearch.categoria; i++) {
            if (formDataSearch.categoria == categoriasOptions[i]) {
                placeholder = categoriasDescripciones[i];
                break;
            }
        }
        if (placeholder)
            setDescripcionPlaceholder(placeholder);
    }, [formDataSearch, location]);

    useEffect(() => {
        if (!categoria || categoriasOptions.length === 0) return;

        const existe = categoriasOptions.includes(categoria);
        const seleccion = existe ? categoria : "Otra";

        setFormDataSearch(prev => ({
            ...prev,
            categoria: seleccion,
            descripcion_servicio: ""
        }));
        setFormDataSearchAct(prev => ({
            ...prev,
            categoria: seleccion
        }));
    }, [categoria, categoriasOptions]);

    const get_categorias = () => {
        axios.post(`${path_api}/default/get_categorias.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setCategoriasOptions(response.data.categorias);
                setCategoriasDescripciones(response.data.descripciones);
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se cargaron las categorias", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al cargar las categorias", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
    };

    const get_estados_ciudades = () => {
        axios.post(`${path_api}/default/get_estados_ciudades.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                const estados = response.data.estados;
                setEstadosCiudades(estados);
                setFormDataSearch(prev => {
                    const newEstado = prev.estado || (estados.length > 0 ? estados[0].nombre : "");
                    const estadoObj = estados.find(e => e.nombre === newEstado);
                    const newCiudad = prev.ciudad || (estadoObj && estadoObj.ciudades && estadoObj.ciudades.length > 0
                        ? estadoObj.ciudades[0].nombre
                        : "");
                    return {
                        ...prev,
                        estado: newEstado,
                        ciudad: newCiudad
                    };
                });
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se cargaron los estados y ciudades",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar estados y ciudades",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });
    };

    const get_profiles = () => {
        let search = formDataSearchAct;
        globals.openViewCharge();
        axios.post(`${path_api}/default/get_profiles.php`, {
            rute: globals.getRuteBackend(),
            search: search
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setProfesionales(response.data.profiles);
                setProfesionalesRecomendados(response.data.profiles_recommended);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se cargaron los perfiles",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar los perfiles",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "categoria") {
            setFormDataSearch(prev => ({
                ...prev,
                categoria: value,
                descripcion_servicio: ""
            }));
            const index = categoriasOptions.findIndex(cat => cat === value);
            if (index !== -1) {
                setDescripcionPlaceholder(categoriasDescripciones[index]);
            }
        } else if (name === "estado") {
            const selectedState = estadosCiudades.find(item => item.nombre === value);
            const newCiudad = selectedState && selectedState.ciudades && selectedState.ciudades.length > 0
                ? selectedState.ciudades[0].nombre
                : "";
            setFormDataSearch(prev => ({
                ...prev,
                estado: value,
                ciudad: newCiudad,
            }));
        } else {
            setFormDataSearch(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        localStorage.setItem('formDataSearch', JSON.stringify(formDataSearch));
        setFormDataSearchAct(formDataSearch);
        navigate(`/categorias/${formDataSearch.categoria}`);
    };

    return (
        <>
            <div className="app-default app-container">
                <NavbarTop />
                <div className="main-content page-categorias">
                    <div className="page-container">
                        <div className="container-banner-all-width" style={{ backgroundImage: `url(${banner1})` }}>
                            <div className='overlay-container-high'></div>

                            <div className='container-section container-search-section'>
                                <div className="container-search-categorias">
                                    {user?.nombre && (
                                        <div className="flex-column gap-10">
                                            <h5>Bienvenido {user.nombre},</h5>
                                            <h2>Encuentra al experto que necesitas</h2>
                                        </div>
                                    )}
                                    {!user?.nombre && (
                                        <h2>Encuentra al experto que necesitas</h2>
                                    )}
                                    <p>¡Chatea con 3 o más profesionales al momento y consigue tu presupuesto ideal! No compartimos tu dirección ni teléfono con nadie.</p>

                                    <form onSubmit={handleSubmit} className="flex-column gap-20">
                                        <div className="form-group">
                                            <label htmlFor="categoria">Categoría</label>
                                            <select
                                                id="categoria"
                                                name="categoria"
                                                value={formDataSearch.categoria}
                                                onChange={handleChange}
                                                className="input-primary"
                                                required
                                            >
                                                {categoriasOptions.map((categoria, index) => (
                                                    <option key={index} value={categoria}>
                                                        {categoria}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="descripcion_servicio">Descripción de servicio</label>
                                            <textarea
                                                type="text"
                                                id="descripcion_servicio"
                                                name="descripcion_servicio"
                                                value={formDataSearch.descripcion_servicio}
                                                onChange={handleChange}
                                                className="input-primary"
                                                placeholder={descripcionPlaceholder}
                                                rows="3"
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Indique estado y ciudad donde se requiere el servicio</label>
                                            <select
                                                id="estado"
                                                name="estado"
                                                value={formDataSearch.estado}
                                                onChange={handleChange}
                                                className="input-primary"
                                                required
                                            >
                                                {estadosCiudades.map((item, index) => (
                                                    <option key={index} value={item.nombre}>
                                                        {item.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            <select
                                                id="ciudad"
                                                name="ciudad"
                                                value={formDataSearch.ciudad}
                                                onChange={handleChange}
                                                className="input-primary"
                                                required
                                            >
                                                {(() => {
                                                    const selectedState = estadosCiudades.find(
                                                        (item) => item.nombre === formDataSearch.estado
                                                    );
                                                    return selectedState && selectedState.ciudades
                                                        ? selectedState.ciudades.map((ciudad) => (
                                                            <option key={ciudad.id} value={ciudad.nombre}>
                                                                {ciudad.nombre}
                                                            </option>
                                                        ))
                                                        : null;
                                                })()}
                                            </select>
                                        </div>


                                        <div className="flex-row justify-end gap-20">
                                            <button className="button-primary" type="submit">Buscar</button>
                                        </div>
                                    </form>
                                </div>
                                <div className="container-img-search-categorias">
                                    <h1>Profesionales de {formDataSearchAct.categoria} en {
                                        formDataSearchAct.estado == 'todo el pais' ?
                                            formDataSearchAct.estado : formDataSearchAct.ciudad + (formDataSearchAct.ciudad == 'todo el estado' ? ' de ' : ', ') + formDataSearchAct.estado}</h1>
                                    <h4>Tenemos el talento<br />y la experiencia que buscas</h4>
                                </div>
                            </div>
                        </div>

                        <div className='container-section margin-top-50 container-profesionales'>
                            <h2>Hay {profesionalesRecomendados.length + profesionales.length} {profesionalesRecomendados.length + profesionales.length == 1 ? "profesional" : "profesionales"} para {formDataSearchAct.categoria} con servicio en el lugar requerido.</h2>
                        </div>

                        <div className='container-section margin-top container-profesionales'>
                            <h4>Recomendados:</h4>
                        </div>

                        <div className='container-section container-profesionales'>
                            {profesionalesRecomendados && profesionalesRecomendados.length > 0 ? (
                                profesionalesRecomendados.map((profesional, index) => (
                                    <Link key={index} className="profesional-item" to={`/ver/profesional/${profesional.keylogin}`}>
                                        <div className="profile">
                                            <img src={path_api + (profesional?.img_profile != '/images/profile_default.png' ? profesional?.account?.img_profile : profesional?.img_profile)}></img>
                                            <div className='flex-column gap-5'>
                                                <h5>{profesional?.nombre + ' ' + profesional?.account?.apellidos}</h5>
                                                {profesional?.average_rating_recieved && (
                                                    <Rating rating={profesional?.average_rating_recieved} size={20} />
                                                )}
                                                {!profesional?.average_rating_recieved && (
                                                    <div className="flex-column">
                                                        <Rating rating={0} size={20} />
                                                        <p>Sin evaluaciones</p>
                                                    </div>
                                                )}
                                                <p>En {profesional.ciudad} - {profesional.estado}</p>
                                            </div>
                                        </div>

                                        <div className='flex-column gap-5'>
                                            <h5>Descripción:</h5>
                                            <p>{profesional?.profile?.descripcion}</p>
                                        </div>
                                    </Link>
                                ))
                            ) : (
                                <h5>No hay profesionales recomendados para mostrar :(</h5>
                            )}
                        </div>

                        <div className='container-section margin-top container-profesionales'>
                            <h4>Otros profesionales:</h4>
                        </div>

                        <div className='container-section container-profesionales'>
                            {profesionales && profesionales.length > 0 ? (
                                profesionales.map((profesional, index) => (
                                    <Link key={index} className="profesional-item" to={`/ver/profesional/${profesional.keylogin}`}>
                                        <div className="profile">
                                            <img src={path_api + (profesional?.img_profile != '/images/profile_default.png' ? profesional?.account?.img_profile : profesional?.img_profile)}></img>
                                            <div className='flex-column gap-5'>
                                                <h5>{typeof (profesional?.profile?.nombre_comercial) == 'string' && profesional?.profile?.nombre_comercial != '' ? profesional?.profile?.nombre_comercial : profesional?.account?.nombre + ' ' + profesional?.account?.apellidos}</h5>
                                                {profesional?.average_rating_recieved && (
                                                    <Rating rating={profesional?.average_rating_recieved} size={20} />
                                                )}
                                                {!profesional?.average_rating_recieved && (
                                                    <div className="flex-column">
                                                        <Rating rating={0} size={20} />
                                                        <p>Sin evaluaciones</p>
                                                    </div>
                                                )}
                                                <p>En {profesional.ciudad} - {profesional.estado}</p>
                                            </div>
                                        </div>

                                        <div className='flex-column gap-5'>
                                            <h5>Descripción:</h5>
                                            <p>{profesional?.profile?.descripcion}</p>
                                        </div>
                                    </Link>
                                ))
                            ) : (
                                <h5>No hay profesionales para mostrar :(</h5>
                            )}
                        </div>

                        <Testimonials />

                        <Preguntas />
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default Categorias;